import { jsx as _jsx } from "react/jsx-runtime";
import Toggle from '@jetbrains/ring-ui/components/toggle/toggle';
export function CWMAvailable(props) {
    const { enabledForProfile, setEnabledForProfile } = props;
    return (_jsx(Toggle, { checked: enabledForProfile, onChange: e => setEnabledForProfile(e.target.checked), children: "Enable Code With Me for profile users" }));
}
